import JackpotValuesControl from "ags/controls/jackpot-values-control";
import { Services } from "slotworks/services/services";
import { Control } from "slotworks/smart-ui/controls/control";
import { JackpotTiers } from "ags/names";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import { asArray } from "slotworks/utils/collection-utils";

export default class CGJackpotValuesControl extends JackpotValuesControl implements Control {

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        const creditSize = options.creditSizes.currentValue;
        const betIndex = options.creditsPerLine.values.indexOf(options.creditsPerLine.currentValue);

        this.setJackpotAmount(JackpotTiers.MINI, asArray(CGJackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MINI))[betIndex] * creditSize);
        this.setJackpotAmount(JackpotTiers.MINOR, asArray(CGJackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MINOR))[betIndex] * creditSize);
        this.setJackpotAmount(JackpotTiers.GRAND, asArray(CGJackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.GRAND))[betIndex] * creditSize);
        this.setJackpotAmount(JackpotTiers.MAJOR, asArray(CGJackpotValuesControl.jackpotOptions.getForTier(JackpotTiers.MAJOR))[betIndex] * creditSize);
    }

    protected setJackpotAmount(jackpot: JackpotTiers, amount: number) {
        this.layer.getText(this.assetName + jackpot).text = Services.currency.format(amount, false, false);
    }
}
